<template>
  <div class="Ftim-box" v-if="infolist">
    <div class="Ftim-bt">
      <span>至德-</span>个人中心
      <i></i>
    </div>

    <div class="Current-box">
      <div class="Currbj-left"></div>

      <all-left></all-left>

      <div class="Current-right">
        <div class="Current-topic">
          <div class="Current-name">我的好友</div>
          <div class="Current-unread">
            <el-input
              placeholder="请输入手机号"
              v-model="issoumobile"
              @keyup.enter.native="sech()"
              clearable
              @clear="handleClear">
            </el-input>
            <span @click="Addphone()">添加</span>
          </div>
        </div>
        <div class="Current-cent">

          <div class="Current-list" v-for="(item, index) in infolist" :key="index">
            <div class="Current-zuo">
              <img :src="item.avatar">
              <span class="Current-title">{{item.name}}</span>
              <i class="Current-phone">{{item.mobile}}</i>
            </div>
            <div class="">
              <span class="Current-shanchu" @click="Liedel(item.id,index)">删除</span>
            </div>
          </div>
        </div>
        <div class="Ftim-more" @click="More" v-if="isgoto">加载更多</div>
      </div>

      <div class="Currbj-right"></div>
    </div>

    <div class="examine-mark" v-if="seetck" @click="Outtck()"></div>
    <div class="operate-tck" v-if="seetck">
      <div class="Current-sobox">
        <div class="Current-sotop">
          <el-input
            placeholder="请输入手机号"
            v-model="adsouphone">
          </el-input>
          <span @click="Phoneso()">查询</span>
        </div>
        <div class="Current-socent" v-if="adinfo != ''">
          <img :src="adinfo.avatar">
          <span class="Current-sotitle">{{adinfo.name}}</span>
          <i class="Current-sophone">{{adinfo.mobile.substr(0,3)+"****"+adinfo.mobile.substr(7)}}</i>
        </div>
        <div class="Current-sobut" @click="Send()">发送好友申请</div>
      </div>
    </div>

  </div>
</template>
<script>
import AllLeft from '../../components/Personleft.vue';//个人中心公用左侧
export default {
  components:{
    AllLeft
  },
  data() {
    return {
      token: localStorage.pctoken,  //获取token
      infolist:[],
      issoumobile:'',      //搜索手机号
      seetck: false,     //是否显示添加手机号弹框
      adsouphone:'',    //添加时搜索手机号
      adinfo:'',        //添加时搜索好友数据
      page: 1,        //当前页码
      isgoto: false   //是否显示加载更多
    };
  },
  created(){
    this.getData();
  },
  mounted() {
  },
  methods: {

    //获取好友数据
    getData(){
      this.$layer.loading();
      this.$http.get('user/friends?page='+this.page,{
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      }).then((res)=>{
        this.$layer.closeAll('loading');
        if(res.data.code == 200){
          this.infolist = this.infolist.concat(res.data.data);
          if(res.data.data.next_page_url != null){
            this.isgoto = true;
            this.page+=1
          }else{
            this.isgoto = false;
          }
        }else{
          this.$layer.msg(res.data.message);
        }
      })
    },
    //搜索好友
    sech(){
      this.$layer.loading();
      this.$http.post('search/user',{
        mobile: this.issoumobile,
      },{
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      }).then((res)=>{
        this.$layer.closeAll('loading');
        if(res.data.code == 200){
          this.infolist = res.data.data;
        }else{
          this.$layer.msg(res.data.message);
        }
      })
    },

    //取消搜索好友
    handleClear() {
      // 调用接口的方法
      this.infolist=[];
      this.getData();
    },

    //点击删除
    Liedel(id,index){
      this.$confirm('是否删除该好友?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$layer.loading();
        this.$http.delete('user/friends?friend_id='+id,{
          headers: {
            'Authorization': 'Bearer ' + this.token
          }
        }).then((res)=>{
          this.$layer.closeAll('loading');
          if(res.data.code == 200){
            this.$layer.msg('删除成功');
            this.infolist.splice(index,1)
          }else{
            this.$layer.msg(res.data.message);
          }
        })
      })
    },

    //点击添加
    Addphone(){
      this.seetck = true;
    },

    //关闭添加
    Outtck(){
      this.seetck = false;
      this.adsouphone='';
      this.adinfo='';
    },

    //添加时搜索
    Phoneso(){
      this.$layer.loading();
      this.$http.post('search/user',{
        mobile: this.adsouphone,
      },{
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      }).then((res)=>{
        this.$layer.closeAll('loading');
        if(res.data.code == 200){
          this.adinfo = res.data.data;
        }else{
          this.$layer.msg(res.data.message);
        }
      })
    },

    //发送好友信息
    Send(){
      this.$layer.loading();
      this.$http.post('user/friends',{
        friend_id: this.adinfo.id,
      },{
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      }).then((res)=>{
        this.$layer.closeAll('loading');
        if(res.data.code == 200){
          this.$layer.msg(res.data.data);
          setTimeout(() => {
            this.seetck = false;
            this.adsouphone='';
            this.adinfo='';
          }, 1800);
        }else{
          this.$layer.msg(res.data.message);
        }
      })
    },

    //加载更多
    More(){
      this.getData();
    }
  },
};
</script>
<style scoped>
  .Ftim-box{
    background: url(../../../public/images/dysjbjt.png) top no-repeat;
    margin-bottom: 20px;
  }
  .Ftim-bt{
    width: 1200px;
    margin: 72px auto 0;
    font-weight: bold;
    font-size: 48px;
    color: #333;
    line-height: 48px;
  }
  .Ftim-bt span{
    color: #D71E1C;
  }
  .Ftim-bt i{
    display: block;
    width: 48px;
    height: 4px;
    background: #D71E1C;
    margin-top: 30px;
  }
  .Current-box{
    width: 1200px;
    margin: 80px auto 0;
    display: flex;
  }
  .Currbj-left{
    width: 30px;
    height: 790px;
    background: url(../../../public/images/grleft.png) bottom no-repeat;
  }
  .Currbj-right{
    width: 30px;
    height: 790px;
    background: url(../../../public/images/grright.png) bottom no-repeat;
  }
  .Current-right{
    flex: 1;
    background: #fff;
    border-left: 1px solid #d8d8d8;
    padding: 40px 0 0 40px;
    height: 700px;
    overflow: auto;
    border-radius: 0 20px 0 0;
  }
  .Current-cent{
    max-height: 640px;
    overflow: auto;
    margin-right: 40px;
  }
  
  .Current-cent::-webkit-scrollbar {
    width: 2px;
    height: 4px;
    margin-top: 10px;
  }

  .Current-cent::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background: rgba(0,0,0,0.2);
  }

  .Current-cent::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 0;
    background: rgba(0,0,0,0.1);
  }
  .Current-topic{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 1px solid #d8d8d8;
    margin-right: 40px;
  }
  .Current-name{
    font-weight: bold;
    font-size: 24px;
    color: #333333;
  }
  .Current-unread{
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
  }
  .Current-unread span{
    width: 64px;
    height: 28px;
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%);
    border-radius: 14px;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    text-align: center;
    margin-left: 10px;
    line-height: 28px;
    cursor: pointer;
  }
  ::v-deep .Current-unread .el-input__inner{
    width: 220px;
    height: 28px;
    background: #F2F2F2;
    border-radius: 14px;
    border: none;
  }
  ::v-deep .Current-unread .el-input__icon{
    line-height: 28px;
    margin-right: 10px;
  }
  .Current-list{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-bottom: 1px solid #D8D8D8;
    margin-top: 20px;
    padding-bottom: 20px;
  }
  .Current-zuo{
    display: flex;
    align-items: center;
  }
  .Current-zuo img{
    width: 56px;
    height: 56px;
    border-radius: 50%;
  }
  .Current-zuo i{
    font-style: normal;
  }
  
  .Current-title{
    font-size: 16px;
    color: #333333;
    margin-left: 15px;
  }
  .Current-phone{
    font-size: 16px;
    color: #D8D8D8;
    margin-left: 20px;
  }
  
  .Current-shanchu{
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    padding-left: 20px;
    background: url(../../../public/images/shanchubjt.png) left no-repeat;
    background-size: 16px 17px;
    line-height: 26px;
    cursor: pointer;
    margin-left: 20px;
  }
  
  .Ftim-more{
    width: 180px;
    height: 36px;
    background: #F2F2F2;
    border-radius: 18px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 36px;
    text-align: center;
    margin: 40px auto 0;
    cursor: pointer;
  }
  .examine-mark{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 3;
  }
  .operate-tck{
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 10;
  }
  .Current-sobox{
    padding: 40px 78px 30px;
    background: #FFFFFF;
    border-radius: 12px;
  }
  .Current-sotop{
    display: flex;
    align-items: center;
  }
  ::v-deep .Current-sotop .el-input__inner{
    width: 250px;
    height: 32px;
    background: #F2F2F2;
    border-radius: 16px;
    border: none;
  }
  .Current-sotop span{
    width: 64px;
    height: 32px;
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%);
    border-radius: 16px;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
  }
  .Current-socent{
    padding: 0 30px;
    height: 96px;
    border-radius: 8px;
    border: 1px solid #D8D8D8;
    margin-top: 20px;
    display: flex;
    align-items: center;
  }
  .Current-socent img{
    width: 56px;
    height: 56px;
    border-radius: 50%;
  }
  .Current-sotitle{
    font-size: 16px;
    color: #333333;
    margin-left: 15px;
  }
  .Current-sophone{
    font-size: 16px;
    color: #D8D8D8;
    margin-left: 20px;
    font-style: normal;
  }
  .Current-sobut{
    width: 200px;
    height: 36px;
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%), #D8D8D8;
    border-radius: 18px;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 36px;
    text-align: center;
    margin: 26px auto 0;
    cursor: pointer;
  }
</style>